export default __webpack_public_path__ + "static/media/ded-contact-telegram.6445a1e9.svg";